var advisorInit;

(function ($) {
	const selectors = {
		wrap: '[data-advisor]',
		intro: '[data-advisor-intro]',
		startBtn: '[data-advisor-start]',
		content: '[data-advisor-content]',
		question: '[data-advisor-question]',
		firstQuestion: '.c-advisor__question.is-first',
		answerBtn: '[data-advisor-answer]',
		selectedAnswer: '.is-selected',
		products: '[data-advisor-products]',
		contactForm: '[data-advisor-contact-form]',
		hiddenField: 'input[name="extra_info"]' // Selector for the hidden field
	};

	advisorInit = function () {
		$(selectors.wrap).each((i, el) => {
			new Advisor(el);
		});
	};

	class Advisor {
		constructor(element) {
			this.$wrap = $(element);

			// Path tracking for form submission
			this.pathData = {
				questions: [],
				answers: []
			};

			this.init();
			this.bind();
		}

		init() {
			this.$intro = this.$wrap.find(selectors.intro);
			this.$startBtn = $(selectors.startBtn);
			this.$content = this.$wrap.find(selectors.content);
			this.$contactForm = this.$wrap.find(selectors.contactForm);
			this.$hiddenField = this.$wrap.find(selectors.hiddenField);

			// Track the path of active questions
			this.activePath = [];

			// Animation duration
			this.animDuration = 400;
		}

		bind() {
			const self = this;

			// Start button click
			this.$startBtn.on('click', function () {
				self.startAdvisor();
			});

			// Answer button clicks
			this.$wrap.on('click', selectors.answerBtn, function () {
				const $btn = $(this);
				const questionId = $btn.data('question-id');
				const answerIndex = $btn.data('advisor-answer');
				const answerType = $btn.data('answer-type');
				const nextQuestionId = $btn.data('next-question');

				self.handleAnswer($btn, questionId, answerIndex, answerType, nextQuestionId);
			});
		}

		startAdvisor() {
			// Hide intro section
			this.$intro.slideUp(this.animDuration);

			// Show content container
			this.$content.slideDown(this.animDuration);

			// Add first question to active path
			const $firstQuestion = this.$wrap.find(selectors.firstQuestion);
			const questionId = $firstQuestion.data('advisor-question');
			const questionText = $firstQuestion.find('.c-advisor__question-title').text().trim();

			this.activePath.push({
				questionId: questionId,
				$element: $firstQuestion
			});

			// Add to path data
			this.addToPathData(questionId, questionText);
		}

		handleAnswer($btn, questionId, answerIndex, answerType, nextQuestionId) {
			const self = this;
			const $question = $btn.closest(selectors.question);

			// Get answer text
			const answerText = $btn.text().trim();

			// Mark this answer as selected
			$question.find(selectors.answerBtn).removeClass('is-selected');
			$btn.addClass('is-selected');

			// Store information about what was visible before making changes
			const visibleProductsBefore = this.$wrap.find(`${selectors.products}:visible`).length > 0;

			// Find the index of this question in the active path
			const pathIndex = this.findPathIndex(questionId);

			// If we found it, remove everything after it from path data and DOM
			if (pathIndex !== -1) {
				// Remove items after this one from the path
				const removedItems = this.activePath.splice(pathIndex + 1);

				// Hide all content that's no longer in our path
				this.hideRemovedContent(questionId, answerIndex);

				// Trim the path data to match the UI state
				this.trimPathData(pathIndex);
			}

			// Add the answer to path data
			this.addAnswerToPathData(questionId, answerText);

			// Check if this is the last visible question (to determine if we should scroll)
			const isLastQuestion = this.isLastVisibleQuestion($question);

			// Show next content based on answer type
			if (answerType === 'question' && nextQuestionId) {
				// Find the next question
				const $nextQuestion = this.$wrap.find(`${selectors.question}[data-advisor-question="${nextQuestionId}"]`);
				const nextQuestionText = $nextQuestion.find('.c-advisor__question-title').text().trim();

				// Check if it's already visible (changing an answer vs. revealing new content)
				const revealingNewQuestion = !$nextQuestion.is(':visible');

				// Get the current question's height for scrolling calculation
				const questionHeight = $question.outerHeight();

				// Show the question
				$nextQuestion.slideDown(this.animDuration, function () {
					// Only scroll if this was the last question AND we're revealing a new question
					if (isLastQuestion && revealingNewQuestion) {
						self.scrollByHeight(questionHeight);
					}
				});

				// Add to active path
				this.activePath.push({
					questionId: nextQuestionId,
					$element: $nextQuestion
				});

				// Add to path data
				this.addToPathData(nextQuestionId, nextQuestionText);

				// Hide contact form when showing a question
				this.$contactForm.slideUp(this.animDuration);
			}
			else if (answerType === 'products') {
				// Find product recommendations
				const $products = this.$wrap.find(`${selectors.products}[data-advisor-products="${questionId}-${answerIndex}"]`);

				// Get product titles for path data
				const productTitles = [];
				$products.find('.c-advisor__product-title').each(function () {
					productTitles.push($(this).text().trim());
				});

				// Add products to path data
				this.addProductsToPathData(productTitles);

				// We should only scroll if:
				// 1. This is the last question
				// 2. There were no products visible before OR we're showing completely new products
				// (not just changing from one product set to another)
				const shouldScroll = isLastQuestion && !visibleProductsBefore;

				// Get the current question's height for scrolling calculation
				const questionHeight = $question.outerHeight();

				// Show the products
				$products.slideDown(this.animDuration, function () {
					// Only scroll when appropriate
					if (shouldScroll) {
						self.scrollByHeight(questionHeight);
					}
				});

				// Show contact form if it's not visible
				if (!this.$contactForm.is(':visible')) {
					this.$contactForm.slideDown(this.animDuration);
				}
			}

			// Update the hidden field
			this.updateHiddenField();
		}

		// Add a question to the path data
		addToPathData(questionId, questionText) {
			this.pathData.questions.push({
				id: questionId,
				text: questionText
			});
		}

		// Add an answer to the path data
		addAnswerToPathData(questionId, answerText) {
			// Find the index of the question in the path data
			const questionIndex = this.pathData.questions.findIndex(q => q.id == questionId);

			// If found, add/update the answer
			if (questionIndex !== -1) {
				// Make sure answers array is at least as long as questions array
				while (this.pathData.answers.length < questionIndex) {
					this.pathData.answers.push('');
				}

				// Set the answer at the matching index
				this.pathData.answers[questionIndex] = answerText;
			}
		}

		// Add products to path data
		addProductsToPathData(productTitles) {
			this.pathData.products = productTitles;
		}

		// Trim path data to match the UI state
		trimPathData(questionIndex) {
			// Keep only up to the specified question index
			this.pathData.questions = this.pathData.questions.slice(0, questionIndex + 1);
			this.pathData.answers = this.pathData.answers.slice(0, questionIndex + 1);

			// Remove products data if we're changing a question
			delete this.pathData.products;
		}

		// Update the hidden field with the current path data
		updateHiddenField() {
			if (!this.$hiddenField.length) return;

			let html = '';

			// Customer Choices Section
			if (this.pathData.questions.length > 0) {
				html += '<div class="x_2141359883specification" style="min-height: 41px; width: 700px; background-color: rgb(113, 184, 255); color: white; text-align: left; padding-left: 20px; display: table"><span style="display: table-cell; vertical-align: middle">CUSTOMER CHOICES</span></div>';
				html += '<div class="x_2141359883specification_value" style="padding: 25px; line-height: 1.5em; font-size: 10pt">';
				html += '<p class="x_2141359883conf_summary_list" id="x_2141359883conf_summary_list"></p>';

				// Add questions and answers
				for (let i = 0; i < this.pathData.questions.length; i++) {
					const question = this.pathData.questions[i];
					const answer = this.pathData.answers[i] || '';

					if (answer) {
						html += '<div class="x_2141359883conf_summary_item" style="width: 100%; margin-bottom: 1em">';
						html += `<div class="x_2141359883conf_summary_name">${question.text.toUpperCase()}</div>`;
						html += `<div class="x_2141359883conf_summary_price" style="color: rgb(113, 184, 255)">${answer}</div>`;
						html += '</div>';
					}
				}

				html += '</div>';
			}

			// Recommended Products Section
			if (this.pathData.products && this.pathData.products.length > 0) {
				html += '<div class="x_2141359883specification" style="min-height: 41px; width: 700px; background-color: rgb(113, 184, 255); color: white; text-align: left; padding-left: 20px; display: table; margin-top: 20px"><span style="display: table-cell; vertical-align: middle">RECOMMENDED PRODUCTS</span></div>';
				html += '<div class="x_2141359883specification_value" style="padding: 25px; line-height: 1.5em; font-size: 10pt">';
				html += '<p class="x_2141359883conf_summary_list" id="x_2141359883conf_summary_list"></p>';

				this.pathData.products.forEach(product => {
					html += '<div class="x_2141359883conf_summary_item" style="width: 100%; margin-bottom: 1em">';
					html += `<div class="x_2141359883conf_summary_name">${product.toUpperCase()}</div>`;
					html += '</div>';
				});

				html += '</div>';
			}

			// Update the hidden field
			this.$hiddenField.val(html);
		}

		// Check if a question is the last visible question
		isLastVisibleQuestion($question) {
			// Get all visible questions
			const $visibleQuestions = this.$wrap.find(`${selectors.question}:visible`);

			// Check if this is the last one
			return $visibleQuestions.last().is($question);
		}

		// Scroll by a specific height
		scrollByHeight(height) {
			const currentScroll = $(window).scrollTop();

			$('html, body').animate({
				scrollTop: currentScroll + height
			}, 500, 'swing');
		}

		findPathIndex(questionId) {
			for (let i = 0; i < this.activePath.length; i++) {
				if (this.activePath[i].questionId == questionId) {
					return i;
				}
			}
			return -1;
		}

		hideRemovedContent(currentQuestionId, selectedAnswerIndex) {
			const self = this;

			// Hide all questions that depend on this one but with different answers
			this.$wrap.find(selectors.question).each(function () {
				const $question = $(this);
				const parentId = $question.data('parent-question');
				const parentAnswer = $question.data('parent-answer');

				// If this question depends on the current question but through a different answer
				if (parentId == currentQuestionId && parentAnswer != selectedAnswerIndex) {
					$question.slideUp(self.animDuration);

					// Also hide any content that depends on this question
					self.hideChildContent($question.data('advisor-question'));
				}
			});

			// Hide all products that depend on this question but with different answers
			this.$wrap.find(selectors.products).each(function () {
				const $products = $(this);
				const parentId = $products.data('parent-question');
				const parentAnswer = $products.data('parent-answer');

				// If these products depend on the current question but through a different answer
				if (parentId == currentQuestionId && parentAnswer != selectedAnswerIndex) {
					$products.slideUp(self.animDuration);
				}
			});
		}

		hideChildContent(questionId) {
			const self = this;

			// Hide all questions that depend on this one
			this.$wrap.find(selectors.question).each(function () {
				const $question = $(this);
				const parentId = $question.data('parent-question');

				// If this question depends on the specified question
				if (parentId == questionId) {
					$question.slideUp(self.animDuration);

					// Also hide any content that depends on this question
					self.hideChildContent($question.data('advisor-question'));
				}
			});

			// Hide all products that depend on this question
			this.$wrap.find(selectors.products).each(function () {
				const $products = $(this);
				const parentId = $products.data('parent-question');

				// If these products depend on the specified question
				if (parentId == questionId) {
					$products.slideUp(self.animDuration);
				}
			});
		}
	}
})(jQuery);

export default advisorInit;